// extracted by mini-css-extract-plugin
module.exports = {"card":"card-small_card__vh0cR","card__title":"card-small_card__title___Vm77"};